import BaseApi from './base'

class Portal extends BaseApi {
  getPlatformTechs = () => this.client.get(`admin/portals`)
}

export default new Portal()
